import { openDatePickerAction, openDateTimePickerAction } from 'actions/datePicker';
import { useDispatch } from 'react-redux';

export function useDatePicker(onDateChange) {
  const dispatch = useDispatch();
  function openDatePicker({
    initialDate = new Date(),
    setEODTime = true,
    setSODTime = false,
    clearable = true,
    minDate = null,
  } = {}) {
    dispatch(
      openDatePickerAction({
        onChange: onDateChange,
        initialDate,
        setEODTime,
        setSODTime,
        clearable,
        minDate,
      })
    );
  }
  return openDatePicker;
}

export function useDateTimePicker(onDateTimeChange) {
  const dispatch = useDispatch();
  function openDateTimePicker({
    initialDate = new Date(),
    endDate,
    openTo,
    clearable = true,
    minDate = null,
    isOneOnOneDatePicker,
  } = {}) {
    dispatch(
      openDateTimePickerAction({
        onChange: onDateTimeChange,
        initialDate,
        endDate,
        openTo,
        clearable,
        minDate,
        isOneOnOneDatePicker,
      })
    );
  }
  return openDateTimePicker;
}
